import { makeStyles, createStyles, Button, Dialog, IconButton, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import { useState, useContext, FC, ChangeEvent } from 'react';
import { FormContext, FormControlProps, registry } from '..';
import { PhotoCamera, AddPhotoAlternate, Close } from '@material-ui/icons';
import { grey } from '@material-ui/core/colors';
import { ImageImportControlDefinition, parseFieldIdentifier } from '../services';
import { delayedUploadImageActions } from '../../../../redux';
import React from 'react';
import Camera, { IMAGE_TYPES, FACING_MODES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import { useDispatch } from 'react-redux';
// var uuidv4 = require("uuid/v4");
import { v4 as uuidv4 } from 'uuid';


require('./ImageCapture.css');
export interface ImageImportProps extends FormControlProps<ImageImportControlDefinition> {
}

let cameraAvailable = false;
function checkCameraAvailable() {
  if (!navigator || !navigator.mediaDevices) {
    cameraAvailable = false;
    return;
  }
  navigator.mediaDevices
    .enumerateDevices()
    .then(function (e) {
      const t = e.find(function (e) {
        return e.kind === 'videoinput';
      });
      cameraAvailable = t !== undefined;
    })
    .catch(function () {
      return (cameraAvailable = false);
    });
}
checkCameraAvailable();
const useStyles = makeStyles(function (e) {
  return createStyles({
    root: {
      // alignSelf: 'center' 
    },
    toolbar: { backgroundColor: 'rgba(a,a,a,2)' },
    cameraBox: { height: '100%', width: '100%', overflow: 'hidden', backgroundColor: 'rgb(0,0,0)' },
    closeButton: { position: 'absolute', top: 0, left: e.spacing(3), color: grey[50] },
    imageWrapper: { width: '100%', height: '100%' },
    image: { display: 'block', marginLeft: 'auto', marginRight: 'auto', maxWidth: '100%', maxHeight: '100%', height: 'auto' },
    confirmBox: { position: 'absolute', width: '100%', bottom: 0, display: 'flex', height: '44px' },
    confirmButton: { flex: 1, backgroundColor: grey[900], opacity: 0.8, color: grey[50], borderRadius: 0, '&:hover': { backgroundColor: grey[600] } },
    allDataUploadedImg: { display: 'block', margin: '6px auto', border: '1px solid #ccc' },
  });
});
export const ImageImport: FC<ImageImportProps> = function(props) {
  const t = props.definition;
  const classes = useStyles({});
  const [ isCameraOn, setIsCameraOn ] = useState(false);
  const [ isDisabled, setIsDisabled ] = useState(false);
  const [ isCameraAvailable, setIsCameraAvailable ] = useState(cameraAvailable);
  const [ hasPendingUpload, setHasPendingUpload ] = useState(false);
  const [ hasOkedPendingUploadDisclaimer, setHasOkedPendingUploadDisclaimer ] = useState(false);
  const [ uri, setURI ] = useState<string | undefined>(undefined);
  const { scope, evalID } = useContext(FormContext);
  const dispatch = useDispatch();

  function onCapture(uri: string) {
    // HACK: There is a slight delay between when the camera dialog appears and when the stream
    // is available.  If the stream is not available, then uri will be 'data:.'.  If this is passed
    // to setURI(), then the client will get errors that the stream isn't present, and the camera
    // control will be disposed before the stream can be closed.  The result is that an extra
    // video stream will remain active in the background.  Performing the check below will prevent
    // this from happening.  Instead, the camera dialog will ignore all capture attempts until
    // the stream is available.
    if (uri !== 'data:,') {
      setURI(uri);
    }
  }
  function onError(error: Error) {
    console.log(error);
    if (error.message.includes('device not found')) {
      cameraAvailable = false;
      setIsCameraAvailable(cameraAvailable);
      setIsCameraOn(false);
    }
  }
  function toggleCamera() {
    setIsCameraOn(!isCameraOn);
  }
  function onDialogClose(_: any, __?: string) {
    toggleCamera();
    setURI(undefined);
  }
  function onKeep() {
    dispatch(delayedUploadImageActions.request({ id: 'temp-'+uuidv4(), uri: uri as string, scope: scope, evalID: evalID as string, path: '{' + parseFieldIdentifier(t.dataPath) + '/-}' }));
    toggleCamera();
    setURI(undefined);
    setHasPendingUpload(true);
  }
  function onDiscard() {
    setURI(undefined);
  }
  function onUpload(files: FileList | null) {
    if (!files) {
      return;
    }
    const reader = new FileReader();
    reader.onload = function () {
      dispatch(delayedUploadImageActions.request({ id: 'temp-'+uuidv4(), uri: reader.result as string, scope: scope, evalID: evalID as string, path: '{' + parseFieldIdentifier(t.dataPath) + '/-}' }));
      setHasPendingUpload(true);
    };
    reader.readAsDataURL(files[0]);
  }
  function renderConfirm() {
    return (
      <div className = { classes.imageWrapper }>
        <img src = { '' + uri } className = { classes.image }></img>
        <div className = { classes.confirmBox }>
          <Button
            variant = { 'text' }
            component = { 'span' }
            onClick = { onDiscard }
            className = { classes.confirmButton }>
              Retake
            </Button>
          <Button
            variant = { 'text' }
            component = { 'span' }
            onClick = { onKeep }
            className = { classes.confirmButton }>
              Accept
            </Button>
        </div>
      </div>
    );
  }
  function renderCamera() {
    return (
      <div style = { { overflow: 'hidden' } }>
        <Camera
          onTakePhoto = { onCapture }
          onCameraError = { onError }
          idealResolution = { { width: 800, height: 600 } }
          imageType = { IMAGE_TYPES.JPG }
          isImageMirror = { false }
          isFullscreen = { true }
          idealFacingMode = { FACING_MODES.ENVIRONMENT }
          // on = { true }
          >
        </Camera>
      </div>
    );
  }
  function renderDialog() {
    const content = uri ? renderConfirm() : renderCamera();
    return (
      <Dialog
        aria-labelledby = { 'simple-dialog-title' }
        fullScreen = { true }
        onClose = { onDialogClose }
        open = { isCameraOn }
        onKeyDown = { function (e) {
          if (e.key === 'Enter' && uri) {
            onKeep();
          }
        } }>
        <div className = { classes.cameraBox }>
          { content }
          {/* typings */}
          <IconButton
            edge = { 'start' }
            color = { 'inherit' }
            aria-label = { 'close' }
            onClick = { onDialogClose }
            className = { classes.closeButton }
            size = { 'medium' }>
            <Close></Close>
          </IconButton>
        </div>
      </Dialog>
    );
  }

  function handlePendingUploadDisclaimerClose() {
    setHasOkedPendingUploadDisclaimer(true);
  }

  function renderButtons() {
    const inputRef = React.createRef<HTMLInputElement>();

    return (
      <div className = { classes.root }>
        { isCameraAvailable &&
          <IconButton
            disabled = { isDisabled }
            onClick = { () => toggleCamera() }>
            <PhotoCamera></PhotoCamera>
          </IconButton>
        }

        <Dialog
          open={hasPendingUpload && !hasOkedPendingUploadDisclaimer}
          onClose={handlePendingUploadDisclaimerClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Upload In Progress"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Please confirm the evaluation status at the bottom of the left navigation panel indicates "All Data Uploaded" before closing the evaluation.
              <br/>
              <img className = { classes.allDataUploadedImg } src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIYAAAAeCAYAAADpTGa/AAAABHNCSVQICAgIfAhkiAAACPhJREFUaEPtWX9M02ca/+zQEpE2A0toBtcE8DJ+XNbTHIe/AqiBu5s1u4HBocOAmhuYnCzZ6nLnqbeAl8yyRPkDNSHARFEX6ZZbL8b25oYRHUcCV3JHWaSQVGpK2iFpay8tkrvn/ZZCLW39FubOet83IbTv8zzv+7zP+3l+vX3pPzQgDMECQRb4kWARwQKhLCAAI5RVhDkIwBBAENICAjBCmiX2J7tvjCzrEAIwlmW+51OYgeKDppvLUk4AxrLM9/wJfx+gYKd6SWhXn7/LXapGoUCRkyVFgeIVVL+pQLpMzHtpIWLwNlVsMhpNdnRohlBc1YnGs7d5H2JJwHCYrTC55vbwujE86oCH95bPJ6Nn6iGGrd/zKcg2Dm/05/W4SC56MZT/Mhsfvb9tXnJUfwh/OVeBspJXuTkGkJ21n/JaeQnAeIiuP2vRbHzs26C/B3ubRmHjtR1fpsc/ONCGL2hRp3nIV0EefA50vdeJ+t45O/GQ4Fi891Bf8QW6rfwEHK4nwRwMjlxKJaeObOcAkrhaBBZBGlqeHjkiAsPT/yU2lFAI8oOAn64+rtG72Pl6C9aW0N/rrSiq/RzHtBYeALJDvZ/2NESzGeN1oP1351FzI9BQj3HrZCtKW3haOdot/8f8E1Ynit7uxDBdduAIBgejMYB0ffwbju2Tz4bAZCONCMDwQK8Zh2e1B1qNOfrQNuOFQ5SB058dwMDFCpytksN2RYtdJ+89BRxRelik073gtHaNAc5HXnR0L/YiBo7gwcDhTytMNtJYEZY4NYLLhiQcVknRceZf0LsyUZ4YljsMIQ6SxHhIEI/czetxLisOu/bfRrMhAw0KL7pPdKOx3wknVqFAWYTThzKRwlby/huX32/BZfooLv4VBo9mwqT5HHsvTMLujUOmIg8fHd2IdVHqM3HjOuo6LTBNUuJf/TLtuQENBzORHkL7id4efHB2BINTcUin/RpUG1GQzBjd4fWeMkOt7kGXgbwxeQ1SqA5L86/tsuCc+jY6+qfhSU7FnvpSqPITOKrDOIAj6gHcuj8LSRbrHOJQEEKn4CmWFtgoCwGCYF7/9+pyBTT6b/H3oQfhWLj5sBHDpBvBcM6rUG7NgzL5ATRfL6UcCtpb9hNU5njR1ztNhAQUHlBC9+kB3P04Gx5tL84b5/hFq1DZ9Fuw4omBgo304iJca6vGQFspCiaHcFwbfT1gI0PasrZAd7Uaug/zEP+1Hu9eCbGO+S7q1BZkHiiHrk2Jd0QjqD35z7lIF05vN7RqHbrxGtra3sY1VR4yRf7zU9RVX0cH8tB2sQqX3opDN4HkFitMvWY0nhiAfVMpvuikyLo7lRyJ3/Bf7gbFPPyeKsiiBht+UIUTCAMMOzS6aeRuZR4sxY5NYgxqRzERbhXe8yJIyOscj9ycRIo8CSkUUVJyFCjLcsNkDqwPngxm8clJSE+m6COTo5L0sZki58iwKiWJaZ0EigIKnKp6BcwBTEHMw7pxTCjyodoqpd5fhvL69cg1fgv9lI8xpN4uM7oNCaiuU2CdTIIshRyFqXMLu8ah7U9AedVPkUt75yrXowST0LONDSPQIwOqg3JkyZKwbrMcPlcIe4IfhBA6lYySslYpqjf5Ql1usRzpmhFozetRK1+OXl7YyLiSLFrXa0f3mR4095IXU+iMJ+/5WdilPRjU3MRxDaUBko8XzQL5oWsR7wzRAoYPaqGPKZFLIKHWkAXkeeemz/ZJNySp4gXPTRZDKnJjjAEjMYzetI6TomAKl26CBttjZhp/q2vB+XmSCDtcj+GYclNqkS+knGDZCN+zM9dgZOw7rvj0R4II7BzpG4OF+89kI42QFhskjxmbcaJxfyvUnPQsnGRwjc6O2oNxkdaLTDOPQGMUoWDfy7DptDhmkqK97Q3K3V6utdNz0kylWXgC+3/zAI5fcGNHUxVq18bD1NqFXZPBW/kuZYLeVFia8g0nTJS3UxSB174g57HSe0GiGCyrB8YqaVICHJNOKrhlPnBMOam2SeBqDJvudmi9ExMothJ4WAO0Nkg3oolXrsHRtt2okQXRKJJI6A3FQudND61mkMDC1wJKIQwY7MUz99CWsHyBBH3vOPf1aUAKkUos+OsdNwrqKtDTtodyLPurxKU3xZi4Q3UH8+6Vs7CYqIhiO4jo+5Qdxrkw+6R2s5xH2KwPMfjVXdT8oR8T+VtwWOG7fB8vA0Gg9ycgM2kW/+gdw8SUA8NmX9rheAmcjNdDOiweK1BYKodH14NjNyiy0COcvvUmOqyp2PHzhaztMY3jltkBm3kMjVfNSNmUjVxaLJ4uxXHfjgm6oNzSDKQb+qH+iqKZ1UqRbYCrtwq5aOCPSEF6J2agfLMHXWeodiCdbQQmy8yclolylCucVMQb0Ec0BzuX/1GQCtsS0SgaW+5hmLMVizz8Rk2ZgmNk7Wdwy8rmj5z6ctFC9fvyuWhxeN8vFtECJxb/VmLsQdHvHVBd3AllYNVvNVBHMYSC5ipU3r+O/WccKGvejVqZBer3qOiSFaGHCsV4/+rsHePwIIzMOCvjIJWlolBJebsszdd5uKxoP3mTOpRpikZxEFPuV6oq0JC/gqp0Kv5ODKGP6sK04m24djQNxlYdvYM8gOURYXH1KsrTv8a1g8HuN5dyrphhJFnpj+k3gvrtqFX4IshgSyf23qEuw+XEmFeEnK0bcbo+G1nMU0cNqPlTP/DWHrQrE+DvSvqoK2Fd0HxXEkFvEK2LS4/fUeqgM6VKsUf1BlTMEbiupIfrSuyUuNLIQS59mM11RB6KpI3qfmhHqENbSTR5Bv7YtB0lPLou9ljFgCGmx6tL9E4RGAnYG1JZaTZOqbZFBEEo4mJghOJ6QeYYMOq82/DNu/yr+Fg4uvKdq1xKYYMBobrsNQ4gDBj+uWjBIQAjFm6eh47+yBGONdrI8X8FjHBGe1Hm2TM3e9Hso87DH0H8Z2Mvnuw3E75DAAZfS8Ug33wqiRIU7KghupIYtICgclgLRBsp/AsJwAhr0tgnLBUU7ORCKon9+38mJxAixjMxa+wvKgAj9u/wmZxAAMYzMWvsL/pf/Mme4LgimQUAAAAASUVORK5CYII="/>
              If you are currently offline, you will need to reopen this evaluation once your current device is online again, and wait for the "All Data Uploaded" message to ensure your image has been uploaded to FARM's server.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handlePendingUploadDisclaimerClose} autoFocus>
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        
        <input
          accept = { 'image/*' }
          id = { 'upload-button' }
          type = { 'file' }
          onChange = { (e: ChangeEvent<HTMLInputElement>) => onUpload(e.target.files) }
          hidden = { true }
          ref = { inputRef }>
        </input>
        <IconButton
          disabled = { isDisabled }
          onClick = { () => inputRef?.current?.click() }>
          <AddPhotoAlternate></AddPhotoAlternate>
        </IconButton>
      </div>
    );
  }
  return uri || (isCameraOn && !isDisabled) ? renderDialog() : renderButtons();
};
registry.registerComponent('ImageImport', ImageImport);
